import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b441128"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "is-tab is-sticky" }
const _hoisted_2 = { class: "resume_contents_wrapper" }
const _hoisted_3 = { class: "resume_layout_item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "resume_title" }, "社会人経験", -1))
const _hoisted_5 = { class: "resume_item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "resume_item_title" }, "就業状況", -1))
const _hoisted_7 = { class: "resume_item_value" }
const _hoisted_8 = { class: "resume_item_value_text" }
const _hoisted_9 = { class: "resume_item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "resume_item_title" }, "経験社数", -1))
const _hoisted_11 = { class: "resume_item_value" }
const _hoisted_12 = { class: "resume_item_value_text" }
const _hoisted_13 = { class: "resume_item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "resume_item_title" }, "社会人経験年数", -1))
const _hoisted_15 = { class: "resume_item_value" }
const _hoisted_16 = { class: "resume_item_value_text" }
const _hoisted_17 = { class: "resume_item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "resume_item_title" }, "マーケティング・デジタル・クリエイティブ領域の経験", -1))
const _hoisted_19 = { class: "resume_item_value" }
const _hoisted_20 = { class: "resume_item_value_text" }
const _hoisted_21 = { class: "resume_item" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "resume_item_title" }, "ポートフォリオサイトのURL", -1))
const _hoisted_23 = { class: "resume_item_value" }
const _hoisted_24 = { class: "resume_item_value_text" }
const _hoisted_25 = { class: "resume_item" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "resume_item_title" }, "ポートフォリオサイトのID", -1))
const _hoisted_27 = { class: "resume_item_value" }
const _hoisted_28 = { class: "resume_item_value_text" }
const _hoisted_29 = { class: "resume_item" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "resume_item_title" }, "ポートフォリオサイトのパスワード", -1))
const _hoisted_31 = { class: "resume_item_value" }
const _hoisted_32 = { class: "resume_item_value_text" }
const _hoisted_33 = { class: "resume_button" }
const _hoisted_34 = { class: "resume_button_inner" }
const _hoisted_35 = { class: "resume_layout_item" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "resume_title" }, "職歴", -1))
const _hoisted_37 = { class: "entry_career_company" }
const _hoisted_38 = { class: "entry_career_company_badge" }
const _hoisted_39 = { class: "entry_career_company_name" }
const _hoisted_40 = { class: "entry_career_company_businesstype" }
const _hoisted_41 = { class: "entry_career_company_item" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "entry_career_company_item_title" }, "職種", -1))
const _hoisted_43 = { class: "entry_career_company_item_content" }
const _hoisted_44 = { class: "entry_career_company_item" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "entry_career_company_item_title" }, "在籍期間", -1))
const _hoisted_46 = {
  key: 0,
  class: "entry_career_company_item_content"
}
const _hoisted_47 = {
  key: 1,
  class: "entry_career_company_item_content"
}
const _hoisted_48 = { class: "entry_career_company_item_2coulumn" }
const _hoisted_49 = { class: "entry_career_company_item_2coulumn_left" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "entry_career_company_item_title" }, "社員数", -1))
const _hoisted_51 = { class: "entry_career_company_item_content" }
const _hoisted_52 = { class: "entry_career_company_item_2coulumn_right" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "entry_career_company_item_title" }, "雇用形態", -1))
const _hoisted_54 = { class: "entry_career_company_item_content" }
const _hoisted_55 = { class: "entry_career_company_item_2coulumn" }
const _hoisted_56 = { class: "entry_career_company_item_2coulumn_left" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "entry_career_company_item_title" }, "月収", -1))
const _hoisted_58 = { class: "entry_career_company_item_content" }
const _hoisted_59 = { class: "entry_career_company_item_2coulumn_right" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "entry_career_company_item_title" }, "年収", -1))
const _hoisted_61 = { class: "entry_career_company_item_content" }
const _hoisted_62 = { class: "entry_career_company_item" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "entry_career_company_item_title" }, "職務内容", -1))
const _hoisted_64 = { class: "entry_career_company_item_content_display_textarea" }
const _hoisted_65 = { class: "entry_career_company_button" }
const _hoisted_66 = ["onClick"]
const _hoisted_67 = ["onClick"]
const _hoisted_68 = { class: "company_edit_button" }
const _hoisted_69 = { class: "company_edit_button_inner" }
const _hoisted_70 = { class: "resume_sticky_button" }
const _hoisted_71 = { class: "resume_sticky_button_inner" }

import { getAdlandexp, getWorkHistoryInfo, WorkHistoryInfo } from '@/api/careersheetEndpoint';
import { getMasterDataListEmpTypeBusicr, getMasterDataListWkStatus, MasterEmpTypeBusicr } from '@/api/masterDataEndpoint';
import BaseButton from '@/components/BaseButton.vue';
import Loading from '@/components/Loading.vue';
import { ref, Ref } from 'vue';
import { useRouter } from 'vue-router';
import TabBar from '@/components/TabBar.vue';
import store from '@/store';

type WorkHistoryList = (WorkHistoryInfo & {
  pushedReadMore: boolean;
})[];

// 職歴の初期設定

export default /*#__PURE__*/_defineComponent({
  __name: 'ResumeView',
  setup(__props) {

const router = useRouter();
const isLoading = ref(false);

// 社会人経験の初期設定
const expcompNum = ref('');
const expYear = ref('');
const expMonth = ref('');
const adlandexp = ref('');
const wkStatus = ref('');
const portfolioSiteUrl = ref('');
const portfolioSiteId = ref('');
const portfolioSitePass = ref('');

const workHistoryList: Ref<WorkHistoryList> = ref([]);
const mstEmpTypeBusicrList: Ref<MasterEmpTypeBusicr[]> = ref([]);
const empTypeName = (emptypeId: number) => {
  return mstEmpTypeBusicrList.value.filter((i) => i.code === emptypeId)[0]?.name || '';
};

const init = async () => {
  isLoading.value = true;
  try {
    const [adlandRes, mstWkStatusRes, workHisRes, mstEmpTypeBusicrRes] = await Promise.all([
      getAdlandexp(),
      getMasterDataListWkStatus(),
      getWorkHistoryInfo(),
      getMasterDataListEmpTypeBusicr(),
      store.dispatch('userMenu/receive'),
    ]);

    // 社会人経験の設定
    expcompNum.value = adlandRes.expcompNum + '社';
    expYear.value = adlandRes.expYearNum + '年';
    expMonth.value = adlandRes.expMonthNum + 'ヵ月';
    if (adlandRes.adlandexpFlg) {
      adlandexp.value = 'あり';
    } else {
      adlandexp.value = 'なし';
    }
    wkStatus.value = mstWkStatusRes.filter((i) => i.code === adlandRes.wkStatusId)[0]?.name || '';
    portfolioSiteUrl.value = adlandRes.portfolioSiteUrl;
    portfolioSiteId.value = adlandRes.portfolioSiteId;
    portfolioSitePass.value = adlandRes.portfolioSitePass;

    // 職務一覧
    workHistoryList.value = workHisRes.workHisInfoList.map((i) => {
      return {
        ...i,
        pushedReadMore: false,
      };
    });
    // 雇用形態マスタ
    mstEmpTypeBusicrList.value = mstEmpTypeBusicrRes;
  } catch (e) {
    console.error(e);
  } finally {
    isLoading.value = false;
  }
};
init();

// 社会人経験編集画面
const transitionEditResumePage = () => {
  router.push({ name: 'e31', query: { ref: 'e' } });
};
// 職歴確認画面
const transitionViewCompanyPage = () => {
  router.push({ name: 'e33', query: { ref: 'e' } });
};
// 希望条件閲覧画面
const transitionViewDesiredPage = () => {
  router.push({ name: 'e40', query: { ref: 'e' } });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
    (!isLoading.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(TabBar),
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("p", _hoisted_8, _toDisplayString(wkStatus.value), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("p", _hoisted_12, _toDisplayString(expcompNum.value), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("p", _hoisted_16, _toDisplayString(expYear.value + expMonth.value), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("p", _hoisted_20, _toDisplayString(adlandexp.value), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("p", _hoisted_24, _toDisplayString(portfolioSiteUrl.value), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("p", _hoisted_28, _toDisplayString(portfolioSiteId.value), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _hoisted_30,
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("p", _hoisted_32, _toDisplayString(portfolioSitePass.value), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createVNode(BaseButton, {
                  theme: "secondary",
                  onClick: transitionEditResumePage
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("社会人経験を変更する")
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workHistoryList.value, (workHistory, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: workHistory.busicrId
                }, [
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, "職歴" + _toDisplayString(index + 1), 1),
                    _createElementVNode("div", _hoisted_39, _toDisplayString(workHistory.compname), 1),
                    _createElementVNode("div", _hoisted_40, _toDisplayString(workHistory.indsctgName), 1),
                    _createElementVNode("div", _hoisted_41, [
                      _hoisted_42,
                      _createElementVNode("div", _hoisted_43, _toDisplayString(workHistory.busicrOcupctgName), 1)
                    ]),
                    _createElementVNode("div", _hoisted_44, [
                      _hoisted_45,
                      (!!workHistory.wkperiodeDateyr && !!workHistory.wkperiodeDatemon)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString(workHistory.wkperiodsDateyr) + "." + _toDisplayString(workHistory.wkperiodsDatemon) + "〜" + _toDisplayString(workHistory.wkperiodeDateyr) + "." + _toDisplayString(workHistory.wkperiodeDatemon), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_47, " 在籍中 " + _toDisplayString(workHistory.wkperiodsDateyr) + "." + _toDisplayString(workHistory.wkperiodsDatemon) + "〜現在 ", 1))
                    ]),
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, [
                        _hoisted_50,
                        _createElementVNode("div", _hoisted_51, _toDisplayString(workHistory.employeeNum ? workHistory.employeeNum : '-') + "人", 1)
                      ]),
                      _createElementVNode("div", _hoisted_52, [
                        _hoisted_53,
                        _createElementVNode("div", _hoisted_54, _toDisplayString(empTypeName(workHistory.emptypeId)), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_55, [
                      _createElementVNode("div", _hoisted_56, [
                        _hoisted_57,
                        _createElementVNode("div", _hoisted_58, _toDisplayString(workHistory.salary ? workHistory.salary : '-') + "万円", 1)
                      ]),
                      _createElementVNode("div", _hoisted_59, [
                        _hoisted_60,
                        _createElementVNode("div", _hoisted_61, _toDisplayString(workHistory.annualincm ? workHistory.annualincm : '-') + "万円", 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_62, [
                      _hoisted_63,
                      _createElementVNode("div", {
                        class: _normalizeClass(["entry_career_company_item_content", { 'is-ellipsis': !workHistory.pushedReadMore }])
                      }, [
                        _createElementVNode("pre", _hoisted_64, _toDisplayString(workHistory.wkcontents), 1)
                      ], 2)
                    ]),
                    _createElementVNode("div", _hoisted_65, [
                      (!workHistory.pushedReadMore)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "button_readmore",
                            onClick: ($event: any) => (workHistory.pushedReadMore = true)
                          }, " もっと見る ", 8, _hoisted_66))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "button_readmore is-close",
                            onClick: ($event: any) => (workHistory.pushedReadMore = false)
                          }, "閉じる", 8, _hoisted_67))
                    ])
                  ])
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_68, [
              _createElementVNode("div", _hoisted_69, [
                _createVNode(BaseButton, {
                  theme: "secondary",
                  onClick: transitionViewCompanyPage
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("職歴を変更する")
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_70, [
            _createElementVNode("div", _hoisted_71, [
              _createVNode(BaseButton, {
                theme: "primary",
                onClick: transitionViewDesiredPage
              }, {
                default: _withCtx(() => [
                  _createTextVNode("希望条件の確認へ進む")
                ]),
                _: 1
              })
            ])
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})